import { render, staticRenderFns } from "./popRemark.vue?vue&type=template&id=bb60498e&scoped=true&"
import script from "./popRemark.vue?vue&type=script&lang=js&"
export * from "./popRemark.vue?vue&type=script&lang=js&"
import style0 from "./popRemark.vue?vue&type=style&index=0&id=bb60498e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb60498e",
  null
  
)

export default component.exports